import {
  getOrderTypeName,
  ProductType,
  getStatusName,
  OrderPriceType,
  getTimeFrameName,
  TimeFrame
} from "../Order/Order";

const headers = [
  { header: "Id", key: "id" },
  { header: "Type", key: "type"},
  { header: "Date", key: "date" },
  { header: "Client account", key: "AccountName" },
  { header: "Product Type", key: "productType"},
  { header: "Product", key: "product" },
  { header: "Ticker", key: "symbol" },
  { header: "Quantity", key: "quantity" },
  { header: "Price", key: "customPrice" },
  { header: "Initiated by", key: "initiatedBy"},
  { header: "Taken by", key: "takenBy"},
  { header: "Status", key: "status" },
];

const getEmptyRowTransfer = () => {
  let row = {};

  headers.forEach(item => (row[item.key] = null));

  return row;
};

const getProductTypeName = transfer => {
  let productType = "";
  if (transfer.items.length > 0&& transfer.items[0].AssetId!=0) {
    productType="ASSET";
  }else{
    productType="CASH";
  }
  return productType;
};
    

const getTransferValues = transfer => {
  const timeFrame = getOrderTimeFrame(transfer);
  let name = ' ';
  if (transfer.CurrentAccount !== undefined) {
    name = transfer.CurrentAccount.HolderName;
  }
  return {
    id: transfer.Id,
    type: transfer.IOType,
    date: transfer.Date,
    timeFrame: timeFrame.name,
    timeFrameDate: timeFrame.date,
    initiatedBy: transfer.InitiatedBy,
    takenBy: transfer.TakenBy,
    productType: getProductTypeName(transfer),
    status: getStatusName(transfer.Status),
  };
};


const buildRows = transfers => {
  let excelRows = [];
  let newTransfers = []

  transfers.todo ? newTransfers =Object.values(transfers).flat(): newTransfers = transfers;
  newTransfers.forEach(transfer => {
    let transferRows = [];

    const transferRow = getTransferValues(transfer);

     transfer.items.forEach(item => {
      let row = getEmptyRowTransfer();

      row = {
        ...row,
        ...transferRow,
        ...{
          product: item.AssetName|| item.CurrencyISO,
          symbol: item.AssetTicker||"-",
          quantity: item.Quantity,
          AccountName:  item.AccountName,
          customPrice: item.AssetTicker==""? "-" :item.Price,
        }
      };

      transferRows.push(row);
      });
    excelRows.push(...transferRows);
  });

  return excelRows;
};

const getOrderPrice = order => {
  let price;

  if (
    [ProductType.EQUITY, ProductType.OPTION, ProductType.FOREX].indexOf(
      order["AssetClassForm"]
    ) >= 0
  ) {
    if (order.OrderType == OrderPriceType.MARKET) {
      price = "";
    } else if (order.OrderType == OrderPriceType.STOPLIMIT) {
      price = `${order.OrderPrice} - ${order.OrderStopPrice}`;
    } else if (order.OrderType == OrderPriceType.STOP) {
      price = order.OrderStopPrice;
    } else {
      price = order.OrderPrice;
    }

    return `${price} ${getOrderTypeName(order.OrderType)}`;
  } else if (
    ProductType.MFUNDS != order["AssetClassForm"] &&
    order["OrderPrice"] != undefined
  ) {
    return order.OrderPrice;
  } else {
    return "";
  }
};

const getOrderTimeFrame = order => {
  if (
    [ProductType.EQUITY, ProductType.OPTION, ProductType.FOREX].indexOf(
      order["AssetClassForm"]
    ) >= 0
  ) {
    return {
      name: getTimeFrameName(order.OrderTimeInForce),
      date: order.OrderTimeInForce == TimeFrame.GTD ? order.OrderGTD : null
    };
  }

  return {};
};

const getOrderSide = order => {
  let side = order.OrderSide;

  if (order["AssetClassForm"] == ProductType.EQUITY) {
    side += order.OrderOpenClose == "Open" ? "-O" : "-C";
  }

  return side;
};

export const getReportIOsData = transfers => {
  return {
    headers,
    rows: buildRows(transfers)
  };
};